import {Grid} from '@yandex-delivery/blocks'
import {HeaderButton} from '@yandex-delivery/order-layout-blocks'
import React from 'react'

import {i18n} from '../../config'

function OtherBusinessesMenu(): React.ReactElement {
  return (
    <Grid container>
      <Grid direction="column" container item xs>
        <Grid item xs>
          <HeaderButton href="/business/restaurants/" size="s" variant="pseudo" transparent>
            {i18n('order.header.link.restaurants-and-caffe', 'Рестораны и кафе')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/business/ecommerce/" size="s" variant="pseudo" transparent>
            {i18n('order.header.link.internet-shops', 'Интернет-магазины')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/business/cosmetics/" size="s" variant="pseudo" transparent>
            {i18n('order.header.link.cosmetics', 'Косметика')}
          </HeaderButton>
        </Grid>
      </Grid>
      <Grid direction="column" container item xs>
        <Grid item xs>
          <HeaderButton href="/business/flowers/" size="s" variant="pseudo" transparent>
            {i18n('order.header.link.flowers', 'Цветы')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/business/children-goods/" size="s" variant="pseudo" transparent>
            {i18n('order.header.link.child', 'Детские товары')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/business/pet-supplies/" size="s" variant="pseudo" transparent>
            {i18n('order.header.link.pets', 'Товары для животных')}
          </HeaderButton>
        </Grid>
      </Grid>
      <Grid direction="column" container item xs>
        <Grid item xs>
          <HeaderButton href="/business/auto-parts/" size="s" variant="pseudo" transparent>
            {i18n('order.header.link.spare-parts', 'Автозапчасти')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/business/appliances/" size="s" variant="pseudo" transparent>
            {i18n('order.header.link.electronic', 'Электроника')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/business/sport-goods/" size="s" variant="pseudo" transparent>
            {i18n('order.header.link.sport', 'Спорттовары')}
          </HeaderButton>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default OtherBusinessesMenu
